import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import metaConfig from "../seo/metaConfig";

const DEFAULT_META = {
  title: "Beema1 – Insurance Simplified",
  description:
    "Beema1 helps you compare and buy insurance online with expert support.",
  keywords: "insurance, online, compare, buy",
  image: "https://beema1.com/og-default.png",
};

const DynamicSEO = () => {
  const { pathname } = useLocation();

  // Helper to find the correct meta for current route
  const getMetaForPath = (path) => {
    return (
      metaConfig
        .slice()
        .sort((a, b) => b.path.length - a.path.length)
        .find((item) => matchPath({ path: item.path, end: true }, path)) ||
      DEFAULT_META
    );
  };

  useEffect(() => {
    const meta = getMetaForPath(pathname);

    document.title = meta.title;

    const setMetaTag = (selector, attrName, value) => {
      let tag = document.head.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        if (attrName === "name")
          tag.setAttribute("name", selector.split("'")[1]);
        if (attrName === "property")
          tag.setAttribute("property", selector.split("'")[1]);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", value);
    };

    const setCanonicalTag = (url) => {
      let link = document.head.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    };

    // Meta tags
    setMetaTag(`meta[name='description']`, "name", meta.description);
    setMetaTag(`meta[name='keywords']`, "name", meta.keywords);

    // OG tags
    setMetaTag(`meta[property='og:site_name']`, "property", "Beema1");
    setMetaTag(`meta[property='og:title']`, "property", meta.title);
    setMetaTag(`meta[property='og:description']`, "property", meta.description);
    setMetaTag(`meta[property='og:type']`, "property", "website");
    setMetaTag(`meta[property='og:url']`, "property", window.location.href);
    setMetaTag(`meta[property='og:image']`, "property", meta.image);

    const canonicalUrl = meta.canonical || `https://beema1.com${pathname}`;
    setCanonicalTag(canonicalUrl);
  }, [pathname]);

  return null; // Nothing to render
};

export default DynamicSEO;
